// Env-matched by hostname, not by any build-time env var — the SAME bundle is served to both
// stg (sebi.app) and prod (biombo.app), so the only thing distinguishing them at runtime is the
// hostname the CRM itself is loaded from.
export function resolveMegaUrl(hostname: string): string {
  return hostname.endsWith('biombo.app') ? 'https://mega.biombo.app' : 'https://mega.sebi.app';
}
